export const COMPANY_MAILBOXES = ['office@maxiron.com', 'accounts@maxiron.com'] as const;

export type CompanyMailbox = (typeof COMPANY_MAILBOXES)[number];

export function defaultSender(kind: 'offer' | 'invoice' | 'customer-order' | 'supplier-order'): CompanyMailbox {
  if (kind === 'invoice' || kind === 'supplier-order') return 'accounts@maxiron.com';
  return 'office@maxiron.com';
}
